import React, {Fragment} from 'react'
import styles from './GearList.scss'
import {urls} from 'lib/urls'
import {Distance} from 'common/units'
import {MiniListItem, MiniListItemDetail} from '../../Dashboard/DashboardElements'
import {IntroWidget} from 'common/IntroWidget'
import _ from 'lodash'

export class GearList extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = { showArchived: false }
  }

  showArchived = (e) => {
    e.preventDefault()
    this.setState({showArchived: true})
  }

  hideArchived = (e) => {
    e.preventDefault()
    this.setState({showArchived: false})
  }

  render () {
    const {showArchived} = this.state
    const {gear} = this.props

    const visibleGear = showArchived ? gear : gear.filter(x => !x.archived)
    const hasArchived = gear.some(x => x.archived)

    if (gear.length === 0) {
      return (
        <IntroWidget i='md-bicycle' link={<a href='/gear/new'>Add Bike</a>}>
          Add a bike to your account to unlock additional features
        </IntroWidget>
      )
    }

    return <Fragment>
      {_.sortBy(visibleGear, 'distance').reverse().map(g =>
        <MiniListItem
          href={urls.gear.show(g.id)}
          key={g.id}
          title={g.name}
          left={<img className={styles.gearImg} src={urls.photos.profile(g.highlightedPhotoId)} />}>
          <MiniListItemDetail><Distance short value={g.distance} /></MiniListItemDetail>
        </MiniListItem>
      )}
      {/* This next conditional will ONLY apply if all the user's gear is archived */}
      {visibleGear.length === 0 && <p>You don't have any unarchived gear. Click below to show all gear.</p>}
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div><a data-card-link href='/gear/new'>Add Bike</a></div>
        <div><a data-card-link href='/gear/new?accessory=true'>Add Accessory</a></div>
        {!showArchived && hasArchived && <div><a data-card-link href='#' onClick={this.showArchived}>Show All</a></div>}
        {showArchived && hasArchived && <div><a data-card-link href='#' onClick={this.hideArchived}>Hide Archived</a></div>}
      </div>
    </Fragment>
  }
}
